import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import { isNil } from "lodash-es"

export default class UserAccountsRoute extends Route {
  @service router
  @service session

  beforeModel(model) {
    if (isNil(this.session.userId)) {
      this.router.transitionTo("/not-found")
    } else {
      this.router.transitionTo("user.show.account", this.session.userId)
    }
  }
}
